<template>
  <nav aria-label="Page navigation" class="navigation" v-if="page.totalPage">
    <ul class="pagination">
      <li :class="{disabled: page.currPage===1}" @click="prev">
        <a aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li :class="{active: (page.currPage==''?1:page.currPage)===1}" title="1" @click="changePage(1)"><a>1</a></li>
      <li v-if="(page.currPage==''?1:page.currPage) > 5"><a>...</a></li>
      <li :title="(page.currPage==''?1:page.currPage) - 3" v-if="(page.currPage==''?1:page.currPage) === 5" @click="changePage((page.currPage==''?1:page.currPage) - 3)"><a>{{ (page.currPage==''?1:page.currPage) - 3 }}</a></li>
      <li :title="(page.currPage==''?1:page.currPage) - 2" v-if="(page.currPage==''?1:page.currPage) - 2 > 1" @click="changePage((page.currPage==''?1:page.currPage) - 2)"><a>{{(page.currPage==''?1:page.currPage) - 2 }}</a></li>
      <li :title="(page.currPage==''?1:page.currPage) - 1" v-if="(page.currPage==''?1:page.currPage) - 1 > 1" @click="changePage((page.currPage==''?1:page.currPage) - 1)"><a>{{ (page.currPage==''?1:page.currPage) - 1 }}</a></li>
      <li class="active" :title="(page.currPage==''?1:page.currPage)" v-if="(page.currPage==''?1:page.currPage) != 1 && (page.currPage==''?1:page.currPage) != page.totalPage"><a>{{ (page.currPage==''?1:page.currPage) }}</a></li>
      <li :title="(page.currPage==''?1:page.currPage) + 1" v-if="(page.currPage==''?1:page.currPage)+ 1 < page.totalPage" @click="changePage((page.currPage==''?1:page.currPage) + 1)"><a>{{ (page.currPage==''?1:page.currPage) + 1 }}</a></li>
      <li :title="(page.currPage==''?1:page.currPage) + 2" v-if="(page.currPage==''?1:page.currPage) + 2 < page.totalPage" @click="changePage((page.currPage==''?1:page.currPage) + 2)"><a>{{ (page.currPage==''?1:page.currPage) + 2 }}</a></li>
      <li :title="(page.currPage==''?1:page.currPage) + 3" v-if="page.totalPage - (page.currPage==''?1:page.currPage) === 4" @click="changePage((page.currPage==''?1:page.currPage) + 3)"><a>{{ (page.currPage==''?1:page.currPage) + 3 }}</a></li>
      <li v-if="page.totalPage - (page.currPage==''?1:page.currPage) >= 5"><a>...</a></li>
      <li v-if="page.totalPage > 1" :class="{active: (page.currPage==''?1:page.currPage)===page.totalPage}" :title="page.totalPage" @click="changePage(page.totalPage)"><a>{{page.totalPage}}</a></li>
      <li :class="{disabled: (page.currPage==''?1:page.currPage)===page.totalPage}" @click="next">
        <a aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
    <div class="jump-operate">
      <div :title="page.currPage + '/' + page.totalPage" class="jump-input">
        跳到
        <input
            class="form-control"
            type="text"
            v-model="page.currPage"
            autocomplete="off"
            spellcheck="false"
            @keydown="keyDown"
            @keyup="keyUp"
            @change="keyUp">
        <span>/</span>
        {{ page.totalPage }}页
      </div>
      <button class="btn" @click="confirm">确定</button>
    </div>
  </nav>
</template>

<script>
/*
  :page {currPage: 1, pageSize: 10, totalCount: 0, totalPage: 0} 需要传递的参数结构
  @on-change 当前页发生变化时，触发事件
*/
export default {
  name: 'pagination',
  props: {
    page: {currPage: 1, pageSize: 10, totalCount: 0, totalPage: 0} // 默认属性：
  },
  data () {
    return {
    }
  },
  created () {
  },
  watch: {
    'page.currPage': {
      handler: function (val) {
        if (val > this.page.totalPage) {
          this.page.currPage = this.page.totalPage
        }
      }
    }
  },
  methods: {
    changePage (page) {
      if (page < 1 || page > this.page.totalPage) return;
      this.$emit('on-change', page);
    },
    confirm () {
      this.changePage(parseInt(this.page.currPage))
    },
    prev () {
      const current = this.page.currPage;
      if (current <= 1) {
        return false;
      }
      this.changePage(current - 1);
    },
    next () {
      const current = this.page.currPage;
      if (current >= this.page.totalPage) {
        return false;
      }
      this.changePage(current + 1);
    },
    keyDown (e) {
      const key = e.keyCode;
      const condition = (key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key === 8 || key === 37 || key === 39;

      if (!condition) {
        e.preventDefault();
      }
    },
    keyUp (e) {
      const key = e.keyCode;
      const val = parseInt(e.target.value);
      if (key === 38) {
        this.prev();
      } else if (key === 40) {
        this.next();
      } else if (key === 13) {
        let page = 1;

        if (val > this.page.totalPage) {
          page = this.page.totalPage;
        } else if (val <= 0 || !val) {
          page = 1;
        } else {
          page = val;
        }
        e.target.value = page;
        this.changePage(page);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .navigation {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    .jump-operate {
      display: inline-block;
      margin: 20px 0 20px 30px;
      .jump-input {
        display: inline-block;
        .form-control {
          display: inline-block;
          width: 48px;
        }
      }
      .btn {
        background-color: #FFFFFF;
        border: 1px solid rgba(0, 0, 0, .1);
        color: @color-base;
        margin-left: 20px;
      }
    }
    li a {
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pagination.vue